
import React from 'react';
import { TabsTrigger } from "@/components/ui/tabs";
import { TabsListWithChildren } from "@/components/ui/tabs-with-children";
import { Activity, Shield, AlertTriangle, Calendar } from 'lucide-react';

interface ComplianceTabsListProps {
  activeTab: string;
}

export const ComplianceTabsList: React.FC<ComplianceTabsListProps> = ({ activeTab }) => {
  return (
    <TabsListWithChildren className="w-full grid grid-cols-1 md:grid-cols-4 mb-8">
      <TabsTrigger value="overview">
        <div className="flex items-center gap-2">
          <Activity className="h-4 w-4" />
          Overview
        </div>
      </TabsTrigger>
      <TabsTrigger value="communications">
        <div className="flex items-center gap-2">
          <Shield className="h-4 w-4" />
          Communications
        </div>
      </TabsTrigger>
      <TabsTrigger value="disclosures">
        <div className="flex items-center gap-2">
          <AlertTriangle className="h-4 w-4" />
          Disclosures
        </div>
      </TabsTrigger>
      <TabsTrigger value="reports">
        <div className="flex items-center gap-2">
          <Calendar className="h-4 w-4" />
          Reports
        </div>
      </TabsTrigger>
    </TabsListWithChildren>
  );
};
